import { render, staticRenderFns } from "./StTeaserNewsMediaOverview.vue?vue&type=template&id=56cfcdc8"
import script from "./StTeaserNewsMediaOverview.vue?vue&type=script&lang=ts"
export * from "./StTeaserNewsMediaOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports